// https://github.com/colinhacks/zod/issues/2070#issue-1590963851
export const coerceNullToUndefined = <T>(
  value: T | null | undefined,
): T | undefined => {
  return value === null ? undefined : value;
};
